.card {
  block-size: 100%;
  display: flex;
  flex-direction: column;
  border-color: #0000001a;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 12px 28px -16px rgba(16, 16, 43, 0.3);
  }

  :global(.ant-card-head-title) {
    font-weight: 700;
  }

  :global(.ant-card-body) {
    flex: 1;
  }
}

.content {
  inline-size: 100%;
}

.description {
  margin-block-end: 0;
}

.runButton {
  min-width: 120px;
}
